module.exports = "<div class=\"application-stepper\" ng-class=\"{'show': $ctrl.show}\" ui-scrollpoint=\"200\">\n\n    <ul ng-show=\"$ctrl.show\">\n        <li ng-repeat=\"step in $ctrl.steps track by $index\">\n            <a href=\"{{step.link}}\" title=\"{{step.label}}\" du-smooth-scroll du-scrollspy offset=\"214\">\n                <div class=\"step-index\"><div>{{$index + 1}}</div></div>\n                <div class=\"step-label\"><span>{{step.label}}</span></div>\n            </a>\n        </li>\n    </ul>\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./src/main/client/app/shared/application/stepper/application-stepper.html
// module id = 389
// module chunks = 0